import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Arian Mavriqi',
    description: 'Wildlife and nature photography by Arian Mavriqi, a photographer from Kamenica, Kosovo, documenting the birds, mammals and wild places of Kosovo and Albania since 2012.',
    placeholder: 'The wild, waited for.',
    url: getOrigin(),
    ogImage: 'https://arian-mavriqi.cdn.modulify.website/social/arian-mavriqi-black-stork.png'
}

export const navigation: Array<{ label: string, href: string }> = [
    {
        label: 'Index',
        href: '/'
    },
    {
        label: 'Archive',
        href: '/archive'
    },
    {
        label: 'About',
        href: '/about'
    },
    {
        label: 'Contact',
        href: '/contact'
    }
]
